import Message from "@amzn/meridian/message";
import { PropsWithChildren } from "react";
import { BADGE_PHOTO_THUMBNAIL_URL } from "src/config/external-links";

interface UserMessageProps extends PropsWithChildren {
  alias: string;
  datetime?: string;
  maxWidth?: string;
  className?: string;
}
const UserMessage = ({
  alias,
  datetime,
  maxWidth = "100%",
  className = "user-bot-response",
  children,
}: UserMessageProps) => {
  return (
    <div className={className}>
      <Message
        name={alias}
        datetime={datetime}
        avatarImageSource={`${BADGE_PHOTO_THUMBNAIL_URL}${alias}`}
        type="incoming"
        maxWidth={maxWidth}
      >
        {children}
      </Message>
    </div>
  );
};

export default UserMessage;
